import { EventData } from 'lib/EventLogger/Event';
import { EventType, Features, SourcePages, ApiType } from 'lib/EventSchema';
import { VehicleEventInfo } from 'lib/Tracking/types';
import LeadTrackingParams from 'types/Apis/LeadTrackingParams';

interface ApiEventInfo extends VehicleEventInfo {
  feature: Features.leadForm | Features.modalLeadForm | Features.quickPicks;
  errorCode: number;
  errorMessage: string;
  trackingParams: LeadTrackingParams;
  sourcePage: SourcePages;
  sourcePageUrl: string;
  sourcePageCategory: string;
  vin: string;
  price?: number;
  requestedPrice?: number;
}

function event({
  feature,
  errorCode,
  errorMessage,
  trackingParams,
  sourcePage,
  sourcePageUrl,
  sourcePageCategory,
  vin,
  price,
  requestedPrice,
}: ApiEventInfo): EventData {
  return {
    source_page_url: sourcePageUrl,
    source_page_category: sourcePageCategory,
    event_type: EventType.api,
    source_page: sourcePage,
    feature,
    api_type: ApiType.responseFailure,
    event_context: {
      tracking_params: trackingParams,
      response_code: errorCode,
      error_message: errorMessage,
      vin,
      price,
      requested_price: requestedPrice,
    },
  };
}

export default event;
